<div class="page-title">{{ isEditing ? 'Editar' : 'Nova' }} Ação de Glampoints</div>

<p-card>
  <p class="warn" *ngIf="generated">
    Esta ação já foi gerada (glampoints creditados) — não pode mais ser editada.
  </p>

  <form [formGroup]="form" class="form-b4a" (submit)="submit()">
    <span class="p-float-label full-w">
      <input
        pInputText
        id="name"
        formControlName="name"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('name') }"
      />
      <label for="name">Nome da ação *</label>
    </span>
    <small class="error full-w" *ngIf="invalidControl('name')">
      Informe o nome da ação.
    </small>

    <span class="p-float-label full-w">
      <textarea
        pInputTextarea
        id="description"
        rows="2"
        formControlName="description"
      ></textarea>
      <label for="description">Descrição</label>
    </span>

    <span class="p-float-label">
      <p-inputNumber
        inputId="points"
        formControlName="points"
        [min]="1"
        [useGrouping]="false"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('points') }"
      />
      <label for="points">Glampoints por usuária *</label>
    </span>
    <small class="error full-w" *ngIf="invalidControl('points')">
      Informe uma quantidade maior que zero.
    </small>

    <div class="input-switch">
      <p-inputSwitch formControlName="active" inputId="active" />
      <label for="active">Ativa</label>
    </div>

    <div class="buttons">
      <p-button
        label="Cancelar"
        severity="secondary"
        [outlined]="true"
        type="button"
        (onClick)="cancel()"
      />
      <p-button
        *ngIf="!generated"
        [label]="isEditing ? 'Salvar' : 'Criar'"
        icon="pi pi-check"
        type="submit"
        [disabled]="form.invalid"
      />
    </div>
  </form>
</p-card>
